<template>
    <transition name="content-fade">
        <div
            class="card card-shadow-box card-no-border"
            v-show="!this.$root.current_event_is_loaded.length > 0"
            id="catalog_container"
            ref="catalog_container"
        >
            <div class="card-header p-0">
                <div class="row ms-0 me-0">
                    <div class="col catalog_header"></div>
                </div>
            </div>
            <div class="card-body p-4">
                <div v-if="has_next_event" class="row">
                    <div class="col-12">
                        <component
                            :is="next_event_active_component"
                            v-bind:event="next_event"
                            @confirm_next_btn="confirm_next_btn"
                        />
                    </div>
                </div>

                <div v-if="has_other_events" class="row">
                    <div class="col-12">
                        <component
                            :is="list_event_component"
                            v-bind:list_event="list_event"
                        />
                    </div>
                </div>
            </div>
        </div>
    </transition>


</template>

<script>
import {defineComponent, shallowRef} from "vue";
import { callAPI, countElements, isset } from "../../helpers/kiosk-helpers";
import NextEvent from "../events/NextEvent";
import EventsList from "../events/EventsList";

const NextEventComponent = shallowRef(NextEvent);
const ListEventComponent = shallowRef(EventsList);

export default defineComponent({
    name: "CatalogComponent",

    components: {
        'next-event-component': NextEventComponent,
        'list-event-component': ListEventComponent,
    },

    data() {
        return {
            events: [],
            events_loaded: false,
            has_next_event: false,
            has_other_events: false,
            has_products: false,
            next_event: null,
            list_event: null,
            next_event_active_component: null,
            next_event_component: NextEventComponent,
            list_event_component: ListEventComponent,
        }
    },


    methods: {
        loadCatalog()
        {
            this.loadEvents();
        },

        loadEvents()
        {
            this.events_loaded = false;

            callAPI(route('api.kiosk.events.index', { store_id: this.$root.store_id }))
                .then(response => {

                    if(!isset(response['data']['success']) || !isset(response['data']['next_event']))
                    {
                        this.has_other_events = false;
                        return;
                    }

                    if(response['data']['success'] !== 1)
                    {
                        this.has_other_events = false;
                        return;
                    }

                    /*******************************************************
                        NEXT EVENT
                    *******************************************************/
                    if(isset(response['data']['next_event']))
                    {
                        if(countElements(response['data']['next_event']) > 0)
                        {
                            this.next_event_active_component = NextEventComponent;
                            this.next_event = response['data']['next_event'];
                            this.has_next_event = true;
                        }
                    }
                    /*******************************************************
                        FUTURE EVENTS
                    *******************************************************/
                    /*
                    FUTURE EVENTS
                     */

                    this.list_event_component = ListEventComponent;

                    if(isset(response['data']['events']))
                    {
                        if(countElements(response['data']['events']) > 0)
                        {
                            this.list_event = response['data']['events'];
                            this.has_other_events = true;
                        }
                    }

                    this.$root.current_event_is_loaded = this.$root.arrayRemove(this.$root.current_event_is_loaded,'Catalog');
                })
                .catch(error => {
                    this.$root.addErrors('a-107',null,String(error));
                });
        },

        confirm_next_btn()
        {
            this.$root.refreshTicketing();
        },



    },

    created() {
        this.$root.disabled_next_btn = true;
        this.loadCatalog();

    },



});
</script>

<style scoped>

</style>
